function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols);
} return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); });
} return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
} }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps)
    _defineProperties(Constructor.prototype, protoProps); if (staticProps)
    _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
} subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass)
    _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) {
    var NewTarget = _getPrototypeOf(this).constructor;
    result = Reflect.construct(Super, arguments, NewTarget);
}
else {
    result = Super.apply(this, arguments);
} return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
}
else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
} return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
} return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct)
    return false; if (Reflect.construct.sham)
    return false; if (typeof Proxy === "function")
    return true; try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
    return true;
}
catch (e) {
    return false;
} }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
}
else {
    obj[key] = value;
} return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null)
    return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
        return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import UIFormInput from '../../../Components/UI/UIFormInput';
import UICardContainer from '../../../Components/UI/UICardContainer';
import { connect } from 'react-redux';
import { getPairsByBrokerId } from '../../Pairs/List/actions';
import { getBidAsc } from '../../../Components/Brokers/WebSocket/actions';
import RiskTable from './RiskTable';
import RiskTotalValues from './RiskTotalValues';
import Select from 'react-select';
import { getBrokers } from '../../Brokers/List/actions';
import { LINK_CONFLUENCE } from '../../../constants/LINK_CONFLUENCE';
var Risk = /*#__PURE__*/ function (_Component) {
    _inherits(Risk, _Component);
    var _super = _createSuper(Risk);
    function Risk(props) {
        var _this;
        _classCallCheck(this, Risk);
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "handleChangeValue", function (e) {
            var value = e.target.value.replace('/[, ]+/g', '.');
            var params = _defineProperty({}, e.target.id, value);
            _this.setState(function (prev) {
                return _objectSpread(_objectSpread({}, prev), params);
            });
        });
        _defineProperty(_assertThisInitialized(_this), "handleCheckV2", function (e) {
            _this.setState({
                isV2: e.target.checked
            });
        });
        _defineProperty(_assertThisInitialized(_this), "handleSelectPair", function (pair) {
            _this.setState({
                selectedPair: pair
            });
            if (!pair)
                return;
            var pairId = pair.value;
            var params = {
                pairId: pairId
            };
            _this.setState({
                isLoading: true
            });
            _this.props.getBidAsc(params).finally(function () {
                _this.setState({
                    isLoading: false
                });
            });
        });
        _defineProperty(_assertThisInitialized(_this), "handleSelectBroker", function (broker) {
            _this.setState({
                selectedPair: null,
                selectedBroker: broker
            });
            if (!broker)
                return;
            var params = {
                brokerId: broker.value
            };
            _this.setState({
                isLoading: true
            });
            _this.props.getPairsByBrokerId(params).finally(function () {
                _this.setState({
                    isLoading: false
                });
            });
        });
        _defineProperty(_assertThisInitialized(_this), "handleCalcRisk", function () {
            var stepDown = 100;
            var price = _this.props.bidAsc.bid * stepDown / 100;
            var initialValue = {
                sum: Number(_this.state.sum),
                stepDown: stepDown,
                price: price,
                quantity: Number(_this.state.sum) / price
            };
            var result = [initialValue];
            while (true) {
                stepDown = stepDown - stepDown * (Number(_this.state.step) / 100);
                if (Number(_this.state.minDrawn) > Number(stepDown))
                    break;
                var _price = _this.props.bidAsc.bid * stepDown / 100;
                var data = {
                    sum: Number(_this.state.sum),
                    stepDown: Number(stepDown),
                    price: Number(_price),
                    quantity: Number(_this.state.sum) / _price
                };
                result.push(data);
            }
            _this.countFinishResult(result);
        });
        _defineProperty(_assertThisInitialized(_this), "handleCalcRiskV2", function () {
            var stepDown = 100;
            var sum = Number(_this.state.sum);
            var crossPercentage = stepDown - Number(_this.state.percentageStep);
            var price = _this.props.bidAsc.bid * stepDown / 100;
            var initialValue = {
                sum: Number(_this.state.sum),
                stepDown: stepDown,
                price: price,
                quantity: Number(_this.state.sum) / price
            };
            var result = [initialValue];
            while (true) {
                stepDown = stepDown - stepDown * (Number(_this.state.step) / 100);
                if (crossPercentage >= stepDown) {
                    crossPercentage = crossPercentage - Number(_this.state.percentageStep);
                    sum = sum * 2;
                }
                if (Number(_this.state.minDrawn) > Number(stepDown))
                    break;
                var _price2 = _this.props.bidAsc.bid * stepDown / 100;
                var data = {
                    sum: sum,
                    stepDown: Number(stepDown),
                    price: Number(_price2),
                    quantity: sum / _price2
                };
                result.push(data);
            }
            _this.countFinishResult(result);
        });
        _defineProperty(_assertThisInitialized(_this), "countFinishResult", function (result) {
            var finishResult = result.map(function (item) {
                var lastPrice = result[result.length - 1].price;
                var sumSell = lastPrice * item.quantity;
                return _objectSpread(_objectSpread({}, item), {}, {
                    sumSell: sumSell,
                    lost: item.sum - sumSell,
                    lostPercentage: (item.sum - sumSell) / item.sum * 100
                });
            });
            _this.setState({
                result: finishResult
            });
        });
        _defineProperty(_assertThisInitialized(_this), "isDisabledButton", function () {
            if (_this.state.isV2) {
                return !(_this.state.sum && _this.state.step && _this.state.minDrawn && _this.state.sum && _this.state.percentageStep && _this.state.selectedPair);
            }
            return !(_this.state.sum && _this.state.step && _this.state.minDrawn && _this.state.sum && _this.state.selectedPair);
        });
        _defineProperty(_assertThisInitialized(_this), "getPairOptions", function () {
            return _this.props.pairs.map(function (item) {
                return {
                    label: item.name,
                    value: item.id
                };
            });
        });
        _defineProperty(_assertThisInitialized(_this), "getBrokerOptions", function () {
            return _this.props.brokers.map(function (item) {
                return {
                    label: item.name,
                    value: item.id
                };
            });
        });
        _this.state = {
            isLoading: false,
            step: '',
            minDrawn: '',
            sum: '',
            isV2: false,
            percentageStep: '',
            result: [],
            selectedPair: null,
            selectedBroker: null
        };
        return _this;
    }
    _createClass(Risk, [{
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                this.setState({
                    isLoading: true
                });
                this.props.getBrokers().finally(function () {
                    _this2.setState({
                        isLoading: false
                    });
                });
            }
        }, {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ React.createElement(UICardContainer, {
                    title: "Risk",
                    isLoading: this.state.isLoading,
                    link: LINK_CONFLUENCE.risk
                }, /*#__PURE__*/ React.createElement(RiskTotalValues, {
                    result: this.state.result
                }), /*#__PURE__*/ React.createElement(Row, {
                    className: "mb-3"
                }, /*#__PURE__*/ React.createElement(Col, {
                    xs: 2
                }, /*#__PURE__*/ React.createElement(Select, {
                    isClearable: true,
                    options: this.getBrokerOptions(),
                    placeholder: "Select Broker",
                    onChange: this.handleSelectBroker,
                    value: this.state.selectedBroker
                })), /*#__PURE__*/ React.createElement(Col, {
                    xs: 2
                }, /*#__PURE__*/ React.createElement(Select, {
                    isClearable: true,
                    options: this.getPairOptions(),
                    placeholder: "Select Pair",
                    onChange: this.handleSelectPair,
                    value: this.state.selectedPair,
                    isDisabled: !this.state.selectedBroker
                }))), /*#__PURE__*/ React.createElement(Row, {
                    className: "mb-3"
                }, /*#__PURE__*/ React.createElement(Col, {
                    xs: 2
                }, /*#__PURE__*/ React.createElement(UIFormInput, {
                    label: "Step",
                    value: this.state.step,
                    onChange: this.handleChangeValue,
                    type: "number",
                    id: "step"
                })), /*#__PURE__*/ React.createElement(Col, {
                    xs: 2
                }, /*#__PURE__*/ React.createElement(UIFormInput, {
                    label: "Min drawn",
                    value: this.state.minDrawn,
                    onChange: this.handleChangeValue,
                    type: "number",
                    id: "minDrawn"
                })), /*#__PURE__*/ React.createElement(Col, {
                    xs: 2
                }, /*#__PURE__*/ React.createElement(UIFormInput, {
                    label: "Sum",
                    value: this.state.sum,
                    onChange: this.handleChangeValue,
                    type: "number",
                    id: "sum"
                })), /*#__PURE__*/ React.createElement(Col, {
                    xs: this.state.isV2 ? 3 : 1,
                    className: "d-flex align-items-center"
                }, /*#__PURE__*/ React.createElement(Form.Check, {
                    type: "checkbox",
                    label: "V2",
                    onChange: this.handleCheckV2,
                    className: "mr-3"
                }), this.state.isV2 && /*#__PURE__*/ React.createElement(UIFormInput, {
                    label: "Percentage Step",
                    value: this.state.percentageStep,
                    onChange: this.handleChangeValue,
                    type: "number",
                    id: "percentageStep"
                })), /*#__PURE__*/ React.createElement(Col, {
                    xs: 1
                }, /*#__PURE__*/ React.createElement(Button, {
                    onClick: this.state.isV2 ? this.handleCalcRiskV2 : this.handleCalcRisk,
                    disabled: this.isDisabledButton()
                }, "Submit"))), /*#__PURE__*/ React.createElement(RiskTable, {
                    result: this.state.result
                }));
            }
        }]);
    return Risk;
}(Component);
var mapStateToProps = function mapStateToProps(state) {
    return {
        pairs: state.pairs.data,
        bidAsc: state.bidAsc.data,
        brokers: state.brokers.data
    };
};
var mapDispatchToProps = {
    getPairsByBrokerId: getPairsByBrokerId,
    getBidAsc: getBidAsc,
    getBrokers: getBrokers
};
export default connect(mapStateToProps, mapDispatchToProps)(Risk);
